import React from 'react';
import NavDropdown from "./NavDropdown";
import NavDropdownItem from './NavDropdownItem';
import NavItem from './NavItem';
import CommonUtils from '../../util/CommonUtils';

function NavbarNav(props) {

    return (
        props.nav.map((navRec, i) => (
            <ul key={i} className={navRec.className}>
                {
                    navRec.nav.map((item) => (
                        (!item.permission || CommonUtils.hasPermission(item.permission)) && (
                            (item.path || (!item.nav || item.nav.length === 0)) ?
                                <NavItem auth={navRec.auth} key={item.id} nav_id={item.id} {...item} /> :
                                (
                                    <NavDropdown key={item.id} name={item.name} {...item} >
                                        {
                                            item.nav.map((menuItem) => (
                                                (!menuItem.permission || CommonUtils.hasPermission(menuItem.permission)) && (
                                                    <NavDropdownItem auth={navRec.auth} key={menuItem.id} id={menuItem.ref_id} {...menuItem} />
                                                )
                                            ))
                                        }
                                    </NavDropdown>
                                )
                        ))
                    )
                }
            </ul>))
    );
}

export default NavbarNav;